import { HttpErrorResponse } from '@angular/common/http';
import { RetryConfig } from '@vendasta/rx-utils';

// Don't use on mutation calls
export const getCallRetryConfig: RetryConfig = {
  maxAttempts: 5,
  retryDelay: 250,
  timeoutMilliseconds: 10000,
  customRetryChecker: (err: HttpErrorResponse) => {
    // TODO: Remove checking 403 once we solve https://vendasta.jira.com/browse/MEET-532
    return err.status && (err.status >= 500 || err.status === 403);
  },
};

export const meetingSchedulerInitializationRetryConfig = {
  maxAttempts: 5,
  retryDelay: 500,
  timeoutMilliseconds: 10000,
  customRetryChecker: (err: HttpErrorResponse) => {
    // TODO: Remove checking 403 once we solve https://vendasta.jira.com/browse/MEET-532
    return err.status && (err.status >= 500 || err.status === 403);
  },
};

export const meetingSchedulerCreateDefaultMeetingTypesRetryConfig = {
  maxAttempts: 5,
  retryDelay: 250,
  timeoutMilliseconds: 10000,
  customRetryChecker: (err: HttpErrorResponse) => {
    return err.status && err.status >= 500;
  },
};
